export default __webpack_public_path__ + "static/media/video-player.94d8037a.svg";